var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandymanServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.79,24.34c0,0.95-0.2,1.86-0.56,2.68H20.71c-0.32-0.82-0.53-1.73-0.53-2.68c0-3.75,3.05-6.81,6.79-6.81 C30.74,17.53,33.79,20.59,33.79,24.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.23,27.51H20.71c-0.2,0-0.39-0.12-0.46-0.31c-0.37-0.94-0.56-1.9-0.56-2.86c0-4.03,3.27-7.31,7.28-7.31 c4.03,0,7.31,3.28,7.31,7.31c0,1-0.2,1.97-0.6,2.88C33.6,27.4,33.42,27.51,33.23,27.51z M21.05,26.52h11.84 c0.26-0.7,0.4-1.43,0.4-2.18c0-3.48-2.83-6.32-6.32-6.32c-3.47,0-6.29,2.83-6.29,6.32C20.68,25.07,20.81,25.8,21.05,26.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "45.1,13.97 45.1,17.28 8.87,17.28 8.87,13.92  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,17.77H8.87c-0.27,0-0.5-0.22-0.5-0.5v-3.36c0-0.13,0.05-0.26,0.15-0.35c0.09-0.09,0.22-0.14,0.35-0.14 h0l36.23,0.05c0.27,0,0.49,0.22,0.49,0.5v3.3C45.59,17.55,45.37,17.77,45.1,17.77z M9.36,16.78H44.6v-2.31L9.36,14.42V16.78z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.87,
    y: 37.64,
    className: "st0",
    width: 36.23,
    height: 9.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,47.47H8.87c-0.27,0-0.5-0.22-0.5-0.5v-9.34c0-0.27,0.22-0.5,0.5-0.5H45.1c0.27,0,0.5,0.22,0.5,0.5v9.34 C45.59,47.25,45.37,47.47,45.1,47.47z M9.36,46.48H44.6v-8.35H9.36V46.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,17.77h-0.34c-0.27,0-0.5-0.22-0.5-0.5c0-0.27,0.22-0.5,0.5-0.5h0.34c0.27,0,0.5,0.22,0.5,0.5 C45.59,17.55,45.37,17.77,45.1,17.77z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,14.46h-0.71c-0.27,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h0.71c0.27,0,0.5,0.22,0.5,0.5 S45.37,14.46,45.1,14.46z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.87,13.19v33.79H4.89V13.19c0-1.1,0.89-1.97,1.99-1.97S8.87,12.09,8.87,13.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.87,47.47H4.89c-0.27,0-0.5-0.22-0.5-0.5V13.19c0-1.36,1.11-2.46,2.48-2.46c1.37,0,2.48,1.11,2.48,2.46 v33.79C9.36,47.25,9.14,47.47,8.87,47.47z M5.39,46.48h2.99V13.19c0-0.81-0.67-1.47-1.49-1.47c-0.82,0-1.49,0.66-1.49,1.47V46.48z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.07,13.18v33.8H45.1v-33.8c0-1.08,0.89-1.96,1.98-1.96l0,0C48.18,11.21,49.07,12.09,49.07,13.18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.07,47.47H45.1c-0.27,0-0.5-0.22-0.5-0.5v-33.8c0-1.36,1.11-2.46,2.48-2.46c1.37,0,2.48,1.1,2.48,2.46 v33.8C49.56,47.25,49.34,47.47,49.07,47.47z M45.59,46.48h2.98V13.18c0-0.81-0.67-1.47-1.49-1.47s-1.49,0.66-1.49,1.47V46.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.98,18.84l-1.72,7.62h-6.08c0.03-0.12,2.05-9.08,2.01-8.94L43.98,18.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.26,26.96h-6.08c-0.15,0-0.29-0.07-0.39-0.19c-0.09-0.12-0.13-0.27-0.1-0.42l0.66-2.93 c0.58-2.55,1.32-5.87,1.35-6c0,0,0,0,0,0c0.06-0.27,0.32-0.43,0.59-0.37c0.03,0.01,0.06,0.01,0.09,0.02l5.7,1.3 c0.27,0.06,0.43,0.32,0.37,0.59l-1.72,7.62C42.7,26.8,42.5,26.96,42.26,26.96z M36.8,25.97h5.06l1.52-6.75l-4.87-1.11 c-0.14,0.87-0.51,2.49-1.2,5.53L36.8,25.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.66,14.01c-0.79,3.48-4.25,5.66-7.73,4.87c-3.48-0.79-5.67-4.25-4.88-7.73c0.55-2.45,2.42-4.25,4.68-4.83 l-1.12,4.96l2.56,2.1l3.22-0.79l1.12-4.96C48.31,9.14,49.22,11.57,48.66,14.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.38,19.54c-0.52,0-1.04-0.06-1.55-0.17c-3.74-0.85-6.1-4.58-5.25-8.32c0.58-2.56,2.51-4.55,5.04-5.2 c0.17-0.04,0.34,0,0.47,0.12c0.12,0.12,0.18,0.3,0.14,0.46l-1.06,4.66l2.13,1.75l2.68-0.66l1.06-4.66 c0.04-0.17,0.16-0.3,0.32-0.36c0.16-0.05,0.34-0.02,0.48,0.09c2,1.68,2.89,4.31,2.31,6.87l0,0c-0.41,1.81-1.5,3.36-3.07,4.35 C44.95,19.18,43.68,19.54,42.38,19.54z M40.06,7.07c-1.77,0.73-3.09,2.28-3.52,4.19c-0.73,3.21,1.29,6.41,4.51,7.14 c1.55,0.35,3.15,0.08,4.5-0.77c1.35-0.85,2.28-2.17,2.64-3.73c0.43-1.92-0.09-3.88-1.37-5.3l-0.93,4.11 c-0.04,0.18-0.18,0.33-0.37,0.37l-3.22,0.79c-0.15,0.04-0.31,0-0.43-0.1l-2.56-2.1c-0.15-0.12-0.21-0.31-0.17-0.49L40.06,7.07z  M48.66,14.01L48.66,14.01L48.66,14.01z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.34,21.68l-1.08,4.78h-2.07l1.17-5.22c0.13-0.55,0.67-0.89,1.21-0.77C41.12,20.6,41.45,21.15,41.34,21.68 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.26,26.83h-2.07c-0.11,0-0.22-0.05-0.29-0.14c-0.07-0.09-0.1-0.2-0.07-0.31L39,21.16 c0.08-0.37,0.3-0.68,0.62-0.87c0.31-0.19,0.68-0.25,1.03-0.17c0.73,0.17,1.2,0.9,1.05,1.64c0,0,0,0,0,0.01l-1.08,4.78 C40.58,26.71,40.43,26.83,40.26,26.83z M38.65,26.09h1.31l1.01-4.48c0.07-0.35-0.15-0.69-0.49-0.77 c-0.16-0.04-0.33-0.01-0.47,0.08c-0.15,0.09-0.25,0.24-0.29,0.41L38.65,26.09z M41.34,21.68L41.34,21.68L41.34,21.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.03,24.09c0,0.86-0.22,1.66-0.59,2.37h-1.57c0.53-0.66,0.84-1.47,0.84-2.37c0-2.05-1.68-3.74-3.74-3.74 s-3.73,1.69-3.73,3.74c0,0.9,0.32,1.71,0.84,2.37h-1.58c-0.37-0.71-0.59-1.51-0.59-2.37c0-2.78,2.27-5.06,5.06-5.06 S32.03,21.32,32.03,24.09z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.05,22.91v2.38l-1.69,0.5c-0.04,0.23-0.12,0.45-0.19,0.67H32.5c0.32-0.72,0.49-1.52,0.49-2.37 c0-3.31-2.7-6.01-6.02-6.01c-3.3,0-6,2.7-6,6.01c0,0.84,0.18,1.65,0.47,2.37h-1.67c-0.07-0.22-0.12-0.44-0.19-0.67l-1.68-0.5 v-2.38l1.68-0.53c0.21-0.82,0.53-1.59,0.98-2.28l-0.83-1.59l1.67-1.67l1.57,0.83c0.7-0.44,1.47-0.77,2.29-0.95l0.53-1.67h2.39 l0.5,1.67c0.82,0.19,1.59,0.52,2.29,0.95l1.58-0.83l1.67,1.67l-0.83,1.59c0.44,0.69,0.78,1.46,0.97,2.28L36.05,22.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.87,
    y: 26.46,
    className: "st0",
    width: 36.23,
    height: 9.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.1,36.29H8.87c-0.27,0-0.5-0.22-0.5-0.5v-9.33c0-0.27,0.22-0.5,0.5-0.5H45.1c0.27,0,0.5,0.22,0.5,0.5v9.33 C45.59,36.06,45.37,36.29,45.1,36.29z M9.36,35.3H44.6v-8.34H9.36V35.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.86,
    y: 26.46,
    className: "st1",
    width: 1.7,
    height: 20.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 26.46,
    className: "st1",
    width: 1.7,
    height: 20.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 8.53,
    y: 35.46,
    className: "st1",
    width: 36.89,
    height: 2.51
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.5,26.46 13.71,26.46 10.89,16.71 14.93,15.49 17.59,23.68 18.2,25.55  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.5,26.96h-4.79c-0.22,0-0.41-0.15-0.48-0.36l-2.81-9.75c-0.07-0.26,0.07-0.53,0.33-0.61l4.03-1.23 c0.26-0.08,0.53,0.06,0.61,0.32l3.57,10.98c0.05,0.15,0.02,0.32-0.07,0.44C18.8,26.88,18.66,26.96,18.5,26.96z M14.08,25.97h3.73 l-3.21-9.87l-3.1,0.94L14.08,25.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.59,10.62l-2.24,0.69c-0.3,0.1-0.59,0.02-0.85-0.14c-1.16-0.79-2.63-0.83-4.03-0.31 c-1.21,0.44-1.83,1.79-1.45,3.03l0.29,0.93c0.08,0.29-0.06,0.56-0.35,0.67l-4.2,1.27c-0.27,0.09-0.56-0.07-0.64-0.34l-0.29-0.93 c-0.59-1.92-2.89-2.75-4.54-1.63c-1.35,0.92-2.73,2.27-4.21,4.54c-0.46,0.71-1.55,0.37-1.51-0.46 c0.12-4.91,4.6-10.39,12.37-12.19c0.35-0.08,0.71,0.04,0.97,0.28c2,1.72,4.7,1.47,5.67-1.14c0.11-0.29,0.33-0.53,0.62-0.61 l2.24-0.69c0.5-0.15,1.01,0.12,1.17,0.62l1.61,5.24C24.37,9.95,24.09,10.48,23.59,10.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.67,11.71c-1.62,1.16-3.04,2.54-4.46,4.08c0.7-1.99,2.14-3.68,3.84-4.94c1.72-1.24,3.77-2.08,5.88-2.14 C9.03,9.6,7.28,10.53,5.67,11.71z M15.61,10.26c-1.11,0.68-1.97,1.7-2.58,2.99c-0.03-1.45,0.88-2.88,2.16-3.68 c1.28-0.78,2.96-0.93,4.26-0.28C18.02,9.26,16.72,9.58,15.61,10.26z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandymanServices);
export default __webpack_public_path__ + "static/media/handyman-services.345c4387ff799aa81981c864eed29299.svg";
export { ForwardRef as ReactComponent };